module.exports = __webpack_public_path__ + "6708df2894e3248a2d266b618593f59c.svg";